export enum PackageDurationType {
  DAY = 'day',
  MONTH = 'month',
  YEAR = 'year'
}

